import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Sidebar from '../components/layout/Sidebar';
import Header from '../components/layout/Header';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Building2, Users } from 'lucide-react';
import { useSafeMode } from '../contexts/SafeModeContext';
import { cn } from '../lib/utils';

// Import the content components
import AdminOrganizationsContent from '../components/admin/AdminOrganizationsContent';
import AdminUsersContent from '../components/admin/AdminUsersContent';

const AdminCustomersPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') || 'organizations';
  const { getThemeColors } = useSafeMode();
  const colors = getThemeColors();

  const handleTabChange = (value) => {
    setSearchParams({ tab: value });
  };

  return (
    <div className={cn("flex h-screen", colors.bgPrimary)}>
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 p-6 overflow-y-auto">
          {/* Page Header */}
          <div className="mb-6">
            <h1 className={cn("text-2xl font-bold", colors.textPrimary)}>
              Customers
            </h1>
            <p className={cn("text-sm mt-1", colors.textMuted)}>
              Manage organizations and users
            </p>
          </div>

          {/* Tabs */}
          <Tabs value={defaultTab} onValueChange={handleTabChange} className="w-full">
            <TabsList className={cn("mb-6 border", colors.bgCard, colors.borderPrimary)}>
              <TabsTrigger 
                value="organizations" 
                className={cn(
                  "data-[state=active]:shadow-sm transition-all flex items-center gap-2",
                  colors.tabActive
                )}
              >
                <Building2 className="w-4 h-4" />
                Organizations
              </TabsTrigger>
              <TabsTrigger 
                value="users" 
                className={cn(
                  "data-[state=active]:shadow-sm transition-all flex items-center gap-2",
                  colors.tabActive
                )}
              >
                <Users className="w-4 h-4" />
                Users
              </TabsTrigger>
            </TabsList>

            <TabsContent value="organizations">
              <AdminOrganizationsContent />
            </TabsContent>

            <TabsContent value="users">
              <AdminUsersContent />
            </TabsContent>
          </Tabs>
        </main>
      </div>
    </div>
  );
};

export default AdminCustomersPage;
